/* eslint-disable prettier/prettier */
import React, {
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO, differenceInDays, addHours } from 'date-fns';

import { Container, Button, Row, Col, Card, Table } from 'react-bootstrap';

import {
  FaComment,
  FaFileDownload,
  FaPenAlt,
  FaWhatsapp,
} from 'react-icons/fa';
import { BiSolidFileTxt } from 'react-icons/bi';
import api from '../../../services/api';

import {
  TIPO_USUARIO,
  formatPrice,
  formataTelefone,
  montaLinkWhatsappWeb,
} from '../../../utils/funcoes';
import getValidationErrors from '../../../utils/getValidationErrors';
import getResponseErrors from '../../../utils/getResponseErrors';
import { optionsSimNao } from '../../../utils/options';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';
import { useAuth } from '../../../hooks/auth';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import SelectSync from '../../../components/SelectSync';
import Loading from '../../../components/Loading';
import Paginacao from '../../../components/Paginacao';
import PageInfo from '../../../components/PageInfo';
import Modal from '../../../components/Modal';
import Historico from '../../../components/Historico';

import ComentarioCadastro, {
  IComentario,
} from '../../CartaoSaudeDetalhe/ComentarioCadastro';
import { Colors } from '../../../styles/constants';
import { CardBody } from '../../CartaoSaudeDetalhe/styles';
import { IDependente } from '../../CartaoSaudeDetalhe';
import ItensVencendo from './ItensVencendo';

import { ContainerIcon, Dependentes, RelatorioHeader } from './styles';

interface IListagemNovos {
  PlaCodigo: number;
  PlaNumero: string;
  PlaDataInicio: Date;
  PlaDataInicioFormatado: string;
  PacNome: string;
  UsuNome: string;
  CliNome: string;
}

interface IListagemCancelados {
  PlaCodigo: number;
  PlaNumero: string;
  PlaRenovado: boolean;
  PlaCanData: Date;
  PlaCanDataFormatado: string;
  PacNome: string;
  UsuNome: string;
  Motivo: string;
  Descricao: string;
  parcelasPagas: number;
  valorMulta: number;
  valorPagoMulta: number;
  multaPaga: boolean;
  valorMultaFormatado: string;
  valorPagoMultaFormatado: string;
  multaPagaFormatado: string;
}

interface IListagemExpirados {
  PlaCodigo: number;
  PlaNumero: string;
  PlaDataFim: Date;
  PlaDataFimFormatado: string;
  diasVencido: number;
  PlaMotData?: Date;
  PlaMotDataFormatado: string;
  PacNome: string;
  PacTelefones: string;
  linkWhatsappWeb: string;
  UsuNome: string;
  Motivo?: string;
  Descricao?: string;
}

export interface IListagemExpirando {
  PlaCodigo: number;
  PlaNumero: string;
  PlaDataFim: Date;
  PlaDataFimFormatado: string;
  PacNome: string;
  UsuNome: string;
  PacTelefones: string;
  PacCPF: string;
  linkWhatsappWeb: string;
}

interface IListagemVencido {
  PlaCodigo: number;
  PlaNumero: string;
  CprDataVenc: Date;
  CprDataVencFormatado: string;
  CprValor: number;
  CprValorFormatado: string;
  PacNome: string;
  UsuNome: string;
  PacTelefones: string;
}

interface IListagemSemUso {
  PlaCodigo: number;
  PlaNumero: string;
  PacNome: string;
  PacCelular: string;
  PacTelefone: string;
  PlaSituacao: number;
  PlaSituacaoFormatado: string;
  PlaStatus: boolean;
  ComComentario?: string;
  ComData?: Date;
  ComDataFormatada?: string;
  linkWhatsappWeb: string;
}

interface IListagemRenovados {
  PlaCodigo: number;
  PlaNumero: string;
  ComData: Date;
  ComDataFormatado: string;
  PacNome: string;
  UsuNome: string;
}

export interface IListagemVencendo {
  CprCodigo: number;
  CprClinica: number;
  PlaCodigo: number;
  PlaNumero: string;
  CprDataVenc: Date;
  CprDataVencFormatado: string;
  CprValor: number;
  CprValorFormatado: string;
  LemData: Date;
  LemDataFormatado: string;
  dadosPaciente: string;
  nomePaciente?: string;
  celular?: string;
  telefone?: string;
  textoMensagem?: string;
  enviaCobranca?: boolean;
}

interface IListagemSiteNaoPago {
  PlaCodigo: number;
  PlaNumero: string;
  PlaDataInicio: Date;
  PlaDataInicioFormatado: string;
  PacNome: string;
}

interface IFormBusca {
  dataInicio: Date;
  dataFim: Date;
  atrasados?: boolean;
  diasAtrasado?: number;
  CliCodigo: string;
  situacao: string;
}

interface IDataExibe {
  dataHora: string;
  dataDiaSemana: string;
}

interface IPaginacao {
  dataInicio: Date;
  dataFim: Date;
  CliCodigo: number;
  situacao: string;
  diasAtrasado?: number;
  limite: number;
  pagina: number;
}

const optionsSituacao = [
  { value: 'novos', label: 'Novos' },
  { value: 'cancelados', label: 'Cancelados' },
  { value: 'expirados', label: 'Expirados' },
  { value: 'expirando', label: 'Expirando' },
  { value: 'vencendo', label: 'Vencendo' },
  { value: 'vencido', label: 'Vencido' },
  { value: 'renovados', label: 'Renovados' },
  { value: 'semuso', label: 'Sem Utilização' },
  { value: 'sitenaopago', label: 'Site Não Pagou 1ª Parcela' },
];

const CartaoSaudeListagem: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();
  const { optionsClinica, imagensClinica } = useClinica();

  const logo =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [listagemNovos, setListagemNovos] = useState<IListagemNovos[]>();
  const [listagemRenovados, setListagemRenovados] = useState<
    IListagemRenovados[]
  >();
  const [listagemCancelados, setListagemCancelados] = useState<
    IListagemCancelados[]
  >();

  const [listagemVencendo, setListagemVencendo] = useState<
    IListagemVencendo[]
  >();

  const [listagemVencido, setListagemVencido] = useState<IListagemVencido[]>();
  const [listagemExpirados, setListagemExpirados] = useState<
    IListagemExpirados[]
  >();
  const [listagemExpirando, setListagemExpirando] = useState<
    IListagemExpirando[]
  >();
  const [listagemSemUso, setListagemSemUso] = useState<IListagemSemUso[]>();

  const [listagemSiteNaoPago, setListagemSiteNaoPago] = useState<
    IListagemSiteNaoPago[]
  >();

  const [totalRegistros, setTotalRegistros] = useState<number | undefined>(
    undefined,
  );
  const [semUsoSelecionado, setSemUsoSelecionado] = useState(false);
  const [siteNaoPagoSelecionado, setSiteNaoPagoSelecionado] = useState(false);
  const [showModalComentario, setShowModalComentario] = useState(false);
  const [showModalDependentes, setShowModalDependentes] = useState(false);
  const [showModalHistorico, setShowModalHistorico] = useState(false);
  const [planoSelecionado, setPlanoSelecionado] = useState<
    IListagemSemUso | undefined
  >(undefined);
  const [dependenteSelecionado, setDependenteSelecionado] = useState<
    IDependente | undefined
  >(undefined);

  const [dependentesAtivos, SetDependentesAtivos] = useState<
    IDependente[] | undefined
  >();

  useEffect(() => {
    if (
      user.UsuTipo > TIPO_USUARIO.ATENDENTE &&
      user.UsuTipo !== TIPO_USUARIO.COBRANCA
    ) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const informacoesPagina = `<b>Descrição:</b> Exibe a listagem de cartões novos, cancelados, expirados, renovados ou sem uso dentro de um determinado período.
  <p><b>*Sem Utilização:</b> Exibe todos os cartões/titulares que possuem Cartão Ativo e que não utilizam os serviços a mais de 60 dias.</p> `;

  function useQuery(): URLSearchParams {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const initialData = useMemo(() => {
    let dataInicio = new Date();
    let dataFim = new Date();
    let submitAutomatico = false;
    if (
      query.get('dataInicio') &&
      query.get('dataInicio')?.length === 10 &&
      query.get('dataFim') &&
      query.get('dataFim')?.length === 10
    ) {
      dataInicio = parseISO(`${query.get('dataInicio')} 03:00:00`);
      dataFim = parseISO(`${query.get('dataFim')} 03:00:00`);
      submitAutomatico = true;
    }

    const CliCodigo = query.get('CliCodigo') || user.UsuClinica.toString();
    const situacao = query.get('situacao') || undefined;

    if (query.get('CliCodigo'))
      formRefBusca.current?.setFieldValue('CliCodigo', query.get('CliCodigo'));

    return {
      dataInicio: format(dataInicio, 'yyyy-MM-dd'),
      dataFim: format(dataFim, 'yyyy-MM-dd'),
      CliCodigo,
      atrasados: 'false',
      situacao,
      submitAutomatico,
    };
  }, [query, user.UsuClinica]);

  const [dataExibe, setDataExibe] = useState<IDataExibe>();
  const [clinica, setClinica] = useState('');
  const [exibeDiasAtrasado, setExibeDiasAtrasado] = useState(false);

  const [paginacao, setPaginacao] = useState<IPaginacao | undefined>(() => {
    if (initialData.submitAutomatico) {
      return {
        dataInicio: parseISO(`${initialData.dataInicio} 03:00:00`),
        dataFim: parseISO(`${initialData.dataFim} 03:00:00`),
        CliCodigo: Number(initialData.CliCodigo),
        situacao: initialData.situacao || 'novos',
        pagina: 1,
        limite: 50,
      };
    }
    return undefined;
  });

  const handleFormataNovos = useCallback((dados: IListagemNovos[]) => {
    const dadosFormatados = dados.map(rel => {
      return {
        ...rel,
        PlaDataInicioFormatado: format(
          parseISO(rel.PlaDataInicio.toString()),
          'dd/MM/yyyy',
        ),
      };
    });
    return dadosFormatados;
  }, []);

  const handleFormataCancelados = useCallback(
    (dados: IListagemCancelados[]) => {
      const dadosFormatados = dados.map(rel => {
        const valorMulta =
          rel.multaPaga && rel.multaPaga === true
            ? rel.valorPagoMulta
            : rel.valorMulta;
        const teveMulta = valorMulta && valorMulta > 0;
        return {
          ...rel,
          PlaCanDataFormatado: format(
            parseISO(rel.PlaCanData.toString()),
            'dd/MM/yyyy',
          ),
          valorMultaFormatado: teveMulta ? formatPrice(valorMulta) : '',
          multaPagaFormatado: teveMulta && rel.multaPaga ? 'Sim' : '',
        };
      });
      return dadosFormatados;
    },
    [],
  );

  const handleFormataExpirados = useCallback((dados: IListagemExpirados[]) => {
    const dadosFormatados = dados.map(rel => {
      const dataFim = parseISO(rel.PlaDataFim.toString());

      const diasVencido = differenceInDays(new Date(), dataFim);

      const dadosPaciente = rel.PacNome.split('#@#');

      const telefones = [];
      if (dadosPaciente[2]) telefones.push(dadosPaciente[2]);
      if (dadosPaciente[3]) telefones.push(dadosPaciente[3]);

      return {
        ...rel,
        PlaDataFimFormatado: format(dataFim, 'dd/MM/yyyy'),
        diasVencido,
        PacNome: dadosPaciente[0],
        PacTelefones: telefones.join(', '),
        linkWhatsappWeb: montaLinkWhatsappWeb(dadosPaciente[3]),
        PlaMotDataFormatado: rel.PlaMotData
          ? format(parseISO(rel.PlaMotData.toString()), 'dd/MM/yyyy')
          : '',
      };
    });
    return dadosFormatados;
  }, []);

  const handleFormataExpirando = useCallback((dados: IListagemExpirando[]) => {
    const dadosFormatados = dados.map(rel => {
      const dataFim = parseISO(rel.PlaDataFim.toString());

      const dadosPaciente = rel.PacNome.split('#@#');

      const telefones = [];
      if (dadosPaciente[2]) telefones.push(dadosPaciente[2]);
      if (dadosPaciente[3]) telefones.push(dadosPaciente[3]);

      return {
        ...rel,
        PlaDataFimFormatado: format(dataFim, 'dd/MM/yyyy'),
        PacNome: dadosPaciente[0],
        PacCPF: dadosPaciente[1],
        PacTelefones: telefones.join(', '),
        linkWhatsappWeb: montaLinkWhatsappWeb(dadosPaciente[3]),
      };
    });
    return dadosFormatados;
  }, []);

  const handleFormataVencidos = useCallback((dados: IListagemVencido[]) => {
    const dadosFormatados = dados.map(rel => {
      const dataVenc = parseISO(rel.CprDataVenc.toString());

      const dadosPaciente = rel.PacNome.split('##');

      const telefones = [];
      if (dadosPaciente[1]) telefones.push(dadosPaciente[1]);
      if (dadosPaciente[2]) telefones.push(dadosPaciente[2]);

      return {
        ...rel,
        CprDataVencFormatado: format(dataVenc, 'dd/MM/yyyy'),
        PacNome: dadosPaciente[0],
        PacTelefones: telefones.join(', '),
        CprValorFormatado: formatPrice(rel.CprValor),
      };
    });
    return dadosFormatados;
  }, []);

  const handleFormataSiteNaoPago = useCallback(
    (dados: IListagemSiteNaoPago[]) => {
      const dadosFormatados = dados.map(rel => {
        return {
          ...rel,
          PlaDataInicioFormatado: format(
            parseISO(rel.PlaDataInicio.toString()),
            'dd/MM/yyyy',
          ),
        };
      });
      return dadosFormatados;
    },
    [],
  );

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        if (!paginacao) return;
        const {
          dataInicio,
          dataFim,
          situacao,
          diasAtrasado,
          CliCodigo,
          limite,
          pagina,
        } = paginacao;
        const dataInicioFormatada = format(dataInicio, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFim, 'yyyy-MM-dd');

        let dataexibeFormatado = `${format(
          dataInicio,
          'dd/MM/yyyy',
        )} até ${format(dataFim, 'dd/MM/yyyy')}`;

        if (situacao === 'semuso') dataexibeFormatado = 'A MAIS DE 60 DIAS';
        if (situacao === 'sitenaopago') dataexibeFormatado = 'TODO O PERÍODO';

        setDataExibe({
          dataDiaSemana: dataexibeFormatado,
          dataHora: format(new Date(), 'dd/MM/yyyy HH:mm'),
        });

        const clinicaBusca = CliCodigo ? `&CliCodigo=${CliCodigo}` : '';

        setListagemNovos(undefined);
        setListagemRenovados(undefined);
        setListagemCancelados(undefined);
        setListagemExpirados(undefined);
        setListagemExpirando(undefined);
        setListagemVencendo(undefined);
        setListagemVencido(undefined);
        setListagemSemUso(undefined);
        setListagemSiteNaoPago(undefined);

        if (situacao === 'novos') {
          const response = await api.get(
            `/relatorios/listagemnovos?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemNovos[] = response.data[0];
          setListagemNovos(handleFormataNovos(dadosApi));
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'cancelados') {
          const response = await api.get(
            `/relatorios/listagemcancelados?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemCancelados[] = response.data[0];
          setListagemCancelados(handleFormataCancelados(dadosApi));
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'expirados') {
          const response = await api.get(
            `/relatorios/listagemexpirados?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemExpirados[] = response.data[0];
          setListagemExpirados(handleFormataExpirados(dadosApi));
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'vencido') {
          const response = await api.get(
            `/relatorios/listagemvencidos?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemVencido[] = response.data[0];
          setListagemVencido(handleFormataVencidos(dadosApi));
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'expirando') {
          const response = await api.get(
            `/relatorios/listagemexpirando?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemExpirando[] = response.data.dados;
          setListagemExpirando(handleFormataExpirando(dadosApi));
          setTotalRegistros(
            response.data.count === 0 ? undefined : response.data.count,
          );
        }
        if (situacao === 'semuso') {
          const parametroAtrasado = diasAtrasado
            ? `&diasAtrasado=${diasAtrasado}`
            : '';
          const response = await api.get(
            `/relatorios/cartoessemuso?${clinicaBusca}&limite=${limite}&pagina=${pagina}${parametroAtrasado}`,
          );
          const dadosApi: IListagemSemUso[] = response.data[0];
          setListagemSemUso(
            dadosApi.map(dados => {
              return {
                ...dados,
                PacCelular: formataTelefone(dados.PacCelular),
                PacTelefone: formataTelefone(dados.PacTelefone),
                PlaSituacaoFormatado:
                  dados.PlaSituacao === 6 ? 'EM DIA' : 'ATRASADO',
                ComDataFormatada: dados.ComData
                  ? format(parseISO(dados.ComData.toString()), 'dd/MM/yy HH:MM')
                  : '',
                linkWhatsappWeb: montaLinkWhatsappWeb(dados.PacCelular),
              };
            }),
          );
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'renovados') {
          const response = await api.get(
            `/relatorios/listagemrenovados?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemRenovados[] = response.data[0];
          setListagemRenovados(
            dadosApi.map(dados => {
              return {
                ...dados,
                ComDataFormatado: dados.ComData
                  ? format(parseISO(dados.ComData.toString()), 'dd/MM/yy HH:MM')
                  : '',
              };
            }),
          );
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'vencendo') {
          const response = await api.get(
            `/relatorios/listagemvencendo?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemVencendo[] = response.data[0];
          setListagemVencendo(
            dadosApi.map(dados => {
              const dadosPaciente = dados.dadosPaciente.split('##');
              return {
                ...dados,
                CprDataVencFormatado: dados.CprDataVenc
                  ? format(parseISO(dados.CprDataVenc.toString()), 'dd/MM/yyyy')
                  : '',
                LemDataFormatado: dados.LemData
                  ? format(addHours(parseISO(dados.LemData.toString()), -3), 'dd/MM/yy HH:mm')
                  : '',
                nomePaciente: dadosPaciente[0] || '',
                celular: dadosPaciente[1] || '',
                telefone: dadosPaciente[2] || '',
                CprValorFormatado: formatPrice(dados.CprValor),
              };
            }),
          );
          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );
        }
        if (situacao === 'sitenaopago') {
          // data é irrelevante
          const dataFormatada = '2023-01-01';
          const response = await api.get(
            `/relatorios/listagemsitenaopago?dataInicio=${dataFormatada}&dataFim=${dataFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
          );
          const dadosApi: IListagemSiteNaoPago[] = response.data.dados;
          setListagemSiteNaoPago(handleFormataSiteNaoPago(dadosApi));
          setTotalRegistros(
            response.data.count === 0 ? undefined : response.data.count,
          );
        }
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    }

    if (paginacao) loadDados();
  }, [
    paginacao,
    addToast,
    handleFormataNovos,
    handleFormataCancelados,
    handleFormataExpirados,
    handleFormataExpirando,
    handleFormataVencidos,
    handleFormataSiteNaoPago,
  ]);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      try {
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          dataInicio: Yup.date().required(),
          dataFim: Yup.date().required(),
          atrasados: Yup.boolean().nullable(true),
          diasAtrasado: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' ? null : value,
            )
            .nullable()
            .optional(),
          CliCodigo: Yup.string().nullable(true),
          situacao: Yup.string().required(),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        setClinica(
          optionsClinica.find(cli => cli.value === dados.CliCodigo)?.label ||
          '',
        );

        const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
        const dataFimSelecionada = parseISO(dados.dataFim.toString());

        setPaginacao({
          dataInicio: dataInicioSelecionada,
          dataFim: dataFimSelecionada,
          CliCodigo: Number(dados.CliCodigo),
          situacao: dados.situacao,
          diasAtrasado:
            dados.atrasados && dados.atrasados.toString() === 'true'
              ? dados.diasAtrasado
              : undefined,
          pagina: 1,
          limite: 50,
        });
      } catch (error) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        }
      }
    },
    [optionsClinica],
  );

  const handleProximaPagina = useCallback((page: number) => {
    setPaginacao(state => {
      return state && { ...state, pagina: page };
    });
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);
  const handleOnChangeSituacao = useCallback(ev => {
    setSemUsoSelecionado(ev.target.value === 'semuso');
    setSiteNaoPagoSelecionado(ev.target.value === 'sitenaopago');
    setExibeDiasAtrasado(false);
  }, []);

  const handleCadastro = useCallback((registro: IListagemSemUso) => {
    setPlanoSelecionado(registro);
    setShowModalComentario(true);
  }, []);

  const handleHistorico = useCallback((dep: IDependente) => {
    setDependenteSelecionado(dep);
    setShowModalHistorico(true);
  }, []);

  const handleDependentes = useCallback(
    async (PlaCodigo: number) => {
      try {
        setLoading(true);
        const response = await api.get<IDependente[]>(
          `planos/etiqueta/${PlaCodigo}`,
        );

        SetDependentesAtivos(
          response.data.filter(
            dep => !dep.DepResponsavel && !dep.DepDataExclusao,
          ),
        );
      } catch (error: any) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }

      setShowModalDependentes(true);
    },
    [addToast],
  );

  const handleRetornoComentario = useCallback(
    (comentario: IComentario) => {
      setListagemSemUso(state => {
        return state && planoSelecionado
          ? state
            .filter(item => item.PlaCodigo !== comentario.ComPlaCodigo)
            .concat([
              {
                ...planoSelecionado,
                ComComentario: comentario.ComComentario,
                ComDataFormatada: comentario.ComDataFormatado,
                ComData: comentario.ComData,
              },
            ])
          : undefined;
      });
      setPlanoSelecionado(undefined);
      setShowModalComentario(false);
    },
    [planoSelecionado],
  );

  const handleDownloadExpirando = useCallback(async () => {
    setLoading(true);
    try {
      if (!paginacao) return;
      const {
        dataInicio,
        dataFim,
        situacao,
        CliCodigo,
        limite,
        pagina,
      } = paginacao;

      if (situacao === 'expirando') {
        const dataInicioFormatada = format(dataInicio, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFim, 'yyyy-MM-dd');
        const clinicaBusca = CliCodigo ? `&CliCodigo=${CliCodigo}` : '';

        const response = await api.get(
          `/relatorios/listagemexpirandoexport?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
        );

        const link = document.createElement('a');
        link.href = response.data.url;
        link.setAttribute(
          'download',
          `expirando${Math.floor(Date.now() / 1000)}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, paginacao]);

  const handleDownloadVencido = useCallback(async () => {
    setLoading(true);
    try {
      if (!paginacao) return;
      const {
        dataInicio,
        dataFim,
        situacao,
        CliCodigo,
        limite,
        pagina,
      } = paginacao;

      if (situacao === 'vencido') {
        const dataInicioFormatada = format(dataInicio, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFim, 'yyyy-MM-dd');
        const clinicaBusca = CliCodigo ? `&CliCodigo=${CliCodigo}` : '';

        const response = await api.get(
          `/relatorios/listagemvencidos/export?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}`,
        );

        const link = document.createElement('a');
        link.href = response.data.url;
        link.target = '_blank';
        link.setAttribute(
          'download',
          `vencido${Math.floor(Date.now() / 1000)}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, paginacao]);

  const handleDownloadExpirados = useCallback(
    async (tipoArquivo?: string) => {
      setLoading(true);
      try {
        if (!paginacao) return;
        const {
          dataInicio,
          dataFim,
          situacao,
          CliCodigo,
          limite,
          pagina,
        } = paginacao;

        if (situacao === 'expirados') {
          const dataInicioFormatada = format(dataInicio, 'yyyy-MM-dd');
          const dataFimFormatada = format(dataFim, 'yyyy-MM-dd');
          const clinicaBusca = CliCodigo ? `&CliCodigo=${CliCodigo}` : '';
          const exportaTXT = tipoArquivo && tipoArquivo === 'txt';
          const parametroTipo = exportaTXT ? '&tipoArquivo=txt' : '';

          const response = await api.get(
            `/relatorios/listagemexpiradosexport?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}&limite=${limite}&pagina=${pagina}${parametroTipo}`,
          );

          const link = document.createElement('a');
          link.href = response.data.url;
          if (exportaTXT) link.target = '_blank';

          const extensaoArquivo = response.data.url
            .toString()
            .split('.')
            .at(-1);
          link.setAttribute(
            'download',
            `expirados${Math.floor(Date.now() / 1000)}.${extensaoArquivo}`,
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, paginacao],
  );

  const handleDownloadVencendo = useCallback(async () => {
    setLoading(true);
    try {
      if (!paginacao) return;
      const { dataInicio, dataFim, situacao, CliCodigo } = paginacao;

      if (situacao === 'vencendo') {
        const dataInicioFormatada = format(dataInicio, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFim, 'yyyy-MM-dd');
        const clinicaBusca = CliCodigo ? `&CliCodigo=${CliCodigo}` : '';

        const response = await api.get(
          `/relatorios/listagemvencendo/export?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}`,
        );

        const link = document.createElement('a');
        link.href = response.data.url;
        link.setAttribute(
          'download',
          `vencendo${Math.floor(Date.now() / 1000)}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, paginacao]);

  const handleDownloadCancelados = useCallback(async () => {
    setLoading(true);
    try {
      if (!paginacao) return;
      const { dataInicio, dataFim, situacao, CliCodigo } = paginacao;

      if (situacao === 'cancelados') {
        const dataInicioFormatada = format(dataInicio, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFim, 'yyyy-MM-dd');
        const clinicaBusca = CliCodigo ? `&CliCodigo=${CliCodigo}` : '';

        const response = await api.get(
          `/relatorios/listagemcancelados/export?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${clinicaBusca}`,
        );

        const link = document.createElement('a');
        link.href = response.data.url;
        link.setAttribute(
          'download',
          `cancelados${Math.floor(Date.now() / 1000)}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, paginacao]);

  const handleDownloadSemUso = useCallback(async () => {
    setLoading(true);
    try {
      if (!paginacao) return;
      const { situacao, diasAtrasado } = paginacao;

      if (situacao === 'semuso') {
        const parametroAtrasado = diasAtrasado
          ? `?diasAtrasado=${diasAtrasado}`
          : '';
        const response = await api.get(
          `/relatorios/cartoessemuso/export${parametroAtrasado}`,
        );

        const link = document.createElement('a');
        link.href = response.data.url;
        link.setAttribute(
          'download',
          `senuso${Math.floor(Date.now() / 1000)}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, paginacao]);

  const handleOnChangeExibeAtrasados = useCallback(ev => {
    setExibeDiasAtrasado(ev.target.value === 'true');
  }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      {showModalComentario && planoSelecionado && (
        <Modal
          show={showModalComentario}
          titulo="Registro de Contato"
          handleFecharModal={() => setShowModalComentario(false)}
        >
          <ComentarioCadastro
            handleRetorno={handleRetornoComentario}
            plaCodigo={planoSelecionado.PlaCodigo}
            origem={11}
          />
        </Modal>
      )}

      {showModalHistorico && dependenteSelecionado && (
        <Modal
          show={showModalHistorico}
          titulo={dependenteSelecionado.paciente.PacNome}
          handleFecharModal={() => {
            setShowModalHistorico(false);
            setDependenteSelecionado(undefined);
          }}
        >
          <Historico pacCodigo={dependenteSelecionado.paciente.PacCodigo} />
        </Modal>
      )}

      {showModalDependentes && dependentesAtivos && (
        <Modal
          show={showModalDependentes}
          titulo="Participantes"
          handleFecharModal={() => setShowModalDependentes(false)}
        >
          <Card>
            {/* <CardHeader>
              <span>
                <FaUser size={15} /> <b>DEPENDENTES</b>
              </span>
            </CardHeader> */}

            <CardBody style={{ height: '241px' }}>
              <Table className="text-secondary" hover size="sm">
                <thead>
                  <tr className="bg-light text-dark">
                    <th>Nome</th>
                    <th>Tipo</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                  {dependentesAtivos?.map(dep => (
                    <tr key={`dep-${dep.DepCodigo}`}>
                      <td>{dep.paciente.PacNome}</td>
                      <td>
                        {dep.DepTitular ? 'Titular' : ''}
                        {dep.DepResponsavel ? 'Responsável' : ''}
                        {!dep.DepTitular && !dep.DepResponsavel
                          ? 'Dependente'
                          : ''}
                      </td>
                      <td>
                        <Dependentes onClick={() => handleHistorico(dep)}>
                          histórico
                        </Dependentes>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Modal>
      )}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">Listagem de Cartões</h2>
            <PageInfo
              descricao={informacoesPagina}
              permissao={TIPO_USUARIO.ATENDENTE}
            />
          </div>
          {optionsClinica.length > 0 && user && (
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col
                  md={2}
                  className={
                    siteNaoPagoSelecionado || semUsoSelecionado ? 'd-none' : ''
                  }
                >
                  <Input
                    name="dataInicio"
                    label="De"
                    type="date"
                    disabled={semUsoSelecionado}
                    required={!semUsoSelecionado}
                  />
                </Col>
                <Col
                  md={2}
                  className={
                    siteNaoPagoSelecionado || semUsoSelecionado ? 'd-none' : ''
                  }
                >
                  <Input
                    name="dataFim"
                    label="Até"
                    type="date"
                    disabled={semUsoSelecionado}
                    required={!semUsoSelecionado}
                  />
                </Col>
                <Col md={2} className={semUsoSelecionado ? '' : 'd-none'}>
                  <Select
                    name="atrasados"
                    label="Exibi Atrasados?"
                    options={optionsSimNao}
                    onChange={handleOnChangeExibeAtrasados}
                  />
                </Col>
                <Col md={2} className={exibeDiasAtrasado ? '' : 'd-none'}>
                  <Input
                    name="diasAtrasado"
                    label="Até Quantos dias Atrasado?"
                    type="number"
                  />
                </Col>
                <Col md={2}>
                  <Select
                    name="situacao"
                    label="Situação"
                    options={optionsSituacao}
                    onChange={handleOnChangeSituacao}
                  />
                </Col>
                <Col md={2}>
                  <SelectSync
                    name="CliCodigo"
                    label="Clinica"
                    options={optionsClinica}
                    isDisabled={user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR}
                    isClearable={user.UsuTipo === TIPO_USUARIO.ADMINISTRADOR}
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                <Col md={1}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
                {paginacao?.situacao === 'expirando' && (
                  <Col md={1}>
                    <br />
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-success"
                      disabled={!listagemExpirando}
                      onClick={() => handleDownloadExpirando()}
                    >
                      <FaFileDownload />
                    </Button>
                  </Col>
                )}
                {paginacao?.situacao === 'expirados' && (
                  <Col md={2}>
                    <br />
                    <Button
                      title="Baixar XLSX"
                      type="button"
                      size="sm"
                      variant="outline-success"
                      disabled={!setListagemExpirados}
                      onClick={() => handleDownloadExpirados()}
                    >
                      <FaFileDownload size={24} />
                    </Button>

                    <Button
                      title="Baixar TXT para Whatsapp"
                      type="button"
                      size="sm"
                      variant="outline-success"
                      className="ml-2"
                      disabled={!setListagemExpirados}
                      onClick={() => handleDownloadExpirados('txt')}
                    >
                      <BiSolidFileTxt size={24} />
                    </Button>
                  </Col>
                )}
                {paginacao?.situacao === 'vencendo' && (
                  <Col md={1}>
                    <br />
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-success"
                      disabled={!listagemVencendo}
                      onClick={() => handleDownloadVencendo()}
                    >
                      <FaFileDownload />
                    </Button>
                  </Col>
                )}
                {paginacao?.situacao === 'vencido' && (
                  <Col md={1}>
                    <br />
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-success"
                      disabled={!listagemVencido}
                      onClick={() => handleDownloadVencido()}
                    >
                      <FaFileDownload />
                    </Button>
                  </Col>
                )}
                {paginacao?.situacao === 'cancelados' && (
                  <Col md={1}>
                    <br />
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-success"
                      disabled={!listagemCancelados}
                      onClick={() => handleDownloadCancelados()}
                    >
                      <FaFileDownload />
                    </Button>
                  </Col>
                )}
                {paginacao?.situacao === 'semuso' && (
                  <Col md={1}>
                    <br />
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-success"
                      disabled={!listagemSemUso}
                      onClick={() => handleDownloadSemUso()}
                    >
                      <FaFileDownload />
                    </Button>
                  </Col>
                )}
              </Row>
            </Form>
          )}
        </div>

        <div className="bg-white border p-2 my-3">
          <img src={logo} alt="Agenda Facil" /> Impresso em{' '}
          {dataExibe?.dataHora}
        </div>

        <RelatorioHeader>
          LISTAGEM DE CARTÕES{' '}
          {paginacao && (
            <>
              {optionsSituacao
                .find(opt => opt.value === paginacao.situacao)
                ?.label.toLocaleUpperCase() || 'ND'}{' '}
            </>
          )}
          {`- ${clinica} -`} {dataExibe?.dataDiaSemana}
        </RelatorioHeader>
        <div className="bg-white border p-2">
          {totalRegistros && totalRegistros > 0 && (
            <b>Total de {totalRegistros} registros</b>
          )}
          {listagemNovos && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>Data Adesão</th>
                    <th>Colaborador</th>
                    <th>Clínica</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemNovos.map(rel => (
                    <tr
                      key={`novos-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PacNome}</td>
                      <td>{rel.PlaDataInicioFormatado}</td>
                      <td>{rel.UsuNome}</td>
                      <td>{rel.CliNome}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemRenovados && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>Data Renovação</th>
                    <th>Colaborador</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemRenovados.map(rel => (
                    <tr
                      key={`novos-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PacNome}</td>
                      <td>{rel.ComDataFormatado}</td>
                      <td>{rel.UsuNome}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemCancelados && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>Parcelas pagas</th>
                    <th>Motivo</th>
                    <th>Descrição</th>
                    <th>Colaborador</th>
                    <th>Multa</th>
                    <th>Pago</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemCancelados.map(rel => (
                    <tr
                      key={`cancelados-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>{rel.PlaNumero}</td>
                      <td>{rel.PacNome}</td>
                      <td>{rel.parcelasPagas}</td>
                      <td>{rel.Motivo}</td>
                      <td>{rel.Descricao}</td>
                      <td>{rel.UsuNome}</td>
                      <td>{rel.valorMultaFormatado}</td>
                      <td>{rel.multaPagaFormatado}</td>
                      <td>{rel.PlaCanDataFormatado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemExpirados && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>Telefone</th>
                    <th>Dias Vencido</th>
                    <th>Motivo</th>
                    <th>Descrição</th>
                    <th>Colaborador</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemExpirados.map(rel => (
                    <tr
                      key={`expirados-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PacNome}</td>
                      <td>
                        <a
                          href={rel.linkWhatsappWeb}
                          target="_blank"
                          rel="noreferrer"
                          className="p-2"
                        >
                          <FaWhatsapp size={18} color="#25D366" />
                        </a>{' '}
                        {rel.PacTelefones}
                      </td>
                      <td>{rel.diasVencido}</td>
                      <td>{rel.Motivo}</td>
                      <td>{rel.Descricao}</td>
                      <td>{rel.UsuNome}</td>
                      <td>{rel.PlaMotDataFormatado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemExpirando && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>CPF</th>
                    <th>Telefones</th>
                    <th>Data Fim</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemExpirando.map(rel => (
                    <tr
                      key={`expirados-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PacNome}</td>
                      <td>{rel.PacCPF}</td>
                      <td>
                        <a
                          href={rel.linkWhatsappWeb}
                          target="_blank"
                          rel="noreferrer"
                          className="p-2"
                        >
                          <FaWhatsapp size={18} color="#25D366" />
                        </a>{' '}
                        {rel.PacTelefones}
                      </td>
                      <td>{rel.PlaDataFimFormatado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemVencido && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>Telefones</th>
                    <th>Data Venc.</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemVencido.map(rel => (
                    <tr
                      key={`vencidos-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PacNome}</td>
                      <td>{rel.PacTelefones}</td>
                      <td>{rel.CprDataVencFormatado}</td>
                      <td>{rel.CprValorFormatado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemVencendo && (
            <>
              <Row noGutters className="bg-light py-2 border-top border-bottom">
                <Col md={1} lg={1}>
                  <b>Nº Cartão</b>
                </Col>
                <Col md={2} lg={5}>
                  <b>Titular</b>
                </Col>
                <Col md={1} lg={1}>
                  <b>Vencimento</b>
                </Col>
                <Col md={2} lg={1}>
                  <b>Telefone</b>
                </Col>
                <Col md={2} lg={1}>
                  <b>Celular</b>
                </Col>
                <Col md={1} lg={1}>
                  <b>Último Envio</b>
                </Col>
                <Col md={2} lg={1}>
                  -
                </Col>
              </Row>
              {listagemVencendo.map(rel => (
                <ItensVencendo contaPR={rel} key={rel.PlaCodigo} />
              ))}
            </>
          )}
          {listagemSemUso && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th style={{ width: '100px' }}>Status</th>
                    <th>Paciente</th>
                    <th style={{ width: '200px' }}>Telefone</th>
                    <th style={{ width: '95px' }}>-</th>
                    <th style={{ width: '95px' }}>-</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemSemUso.map(rel => (
                    <tr
                      key={`semUso-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PlaSituacaoFormatado}</td>
                      <td>{rel.PacNome}</td>
                      <td>
                        <a
                          href={rel.linkWhatsappWeb}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FaWhatsapp size={18} color="#25D366" />
                        </a>{' '}
                        {`${rel.PacCelular} ${rel.PacTelefone}`}
                      </td>
                      <td>
                        <Dependentes
                          onClick={() => handleDependentes(rel.PlaCodigo)}
                        >
                          Dependentes
                        </Dependentes>
                      </td>
                      <td>
                        <Button
                          variant="info"
                          title={`addComentario-${rel.PlaCodigo}`}
                          onClick={() => handleCadastro(rel)}
                        >
                          <FaPenAlt fontSize="14" />
                        </Button>
                        {rel.ComData && (
                          <>
                            <ContainerIcon>
                              <FaComment
                                title={`${rel.ComComentario} - ${rel.ComDataFormatada}`}
                                fontSize={20}
                                color={Colors.success}
                              />
                            </ContainerIcon>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {listagemSiteNaoPago && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Nº Cartão</th>
                    <th>Paciente</th>
                    <th>Data Adesão</th>
                  </tr>
                </thead>
                <tbody>
                  {listagemSiteNaoPago.map(rel => (
                    <tr
                      key={`novos-${rel.PlaCodigo}`}
                      style={{
                        fontSize: '.7rem',
                        height: '30px',
                      }}
                    >
                      <td>
                        <Link
                          to={`/cartaosaudedetalhe/${rel.PlaCodigo}`}
                          target="_blank"
                        >
                          Nº {rel.PlaNumero}
                        </Link>
                      </td>
                      <td>{rel.PacNome}</td>
                      <td>{rel.PlaDataInicioFormatado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          <Paginacao
            limitePagina={paginacao?.limite || 50}
            paginasVizinhas={2}
            totalRegistros={totalRegistros}
            paginaInicio={paginacao?.pagina}
            handleProximaPagina={handleProximaPagina}
          />
        </div>
      </>
    </Container>
  );
};

export default CartaoSaudeListagem;
